export default "__VITE_ASSET__piNAbWzl__"